import axios from 'axios'

// 分页查询最新商品(每个店铺一个商品)
export function productLatest(params) {
  return axios({
    url: `/mall/app/gm/product/latest`,
    method: `get`,
    params
  })
}
// 分页查询最新商品(所有商品)
export function searchAll(params) {
  return axios({
    url: `/mall/app/gm/product/latest/all`,
    method: `get`,
    params
  })
}
// 商品分类
export function categoryProduct(params) {
  return axios({
    url: `/mall/app/gm/product/category`,
    method: `get`,
    params
  })
}
